import React from 'react';
import { governmentAssumptionColumns, governmentAssumptionRows, governmentBaseline, governmentCaveats, governmentFormula, governmentRanges, governmentScopeNote } from '../../data/solutionCatalog';
import { AssumptionsDisclosure } from './AssumptionsDisclosure';

/** Government's two linked illustrative ranges, with the full assumptions table. */
export function GovernmentScenario() {
  return <>
      <div className="mt-5 overflow-x-auto rounded-md border border-line" data-id="element-2445" data-mp="xfj0rj9hi0c">
        <table className="w-full min-w-[40rem] text-left" data-id="element-2446" data-mp="3s2fm54hic58h">
          <caption className="sr-only" data-id="element-2447" data-mp="3s51q6u56w2ly">Illustrative administrative scenarios</caption>
          <thead data-id="element-2448" data-mp="3o1lxg8w8qmej">
            <tr className="border-b border-line bg-surface-bg" data-id="element-2449" data-mp="3o36sdzmgw7cx">
              <th scope="col" className="px-5 py-3 text-sm font-semibold text-ink-dark" data-id="element-2450" data-mp="3j3tvsn5snlx5">Model</th>
              <th scope="col" className="px-5 py-3 text-sm font-semibold text-ink-dark" data-id="element-2451" data-mp="1m9gyidgbqoub">Administrative positions reduced or avoided</th>
              <th scope="col" className="px-5 py-3 text-sm font-semibold text-ink-dark" data-id="element-2452" data-mp="1h91p1wz5y1hm">Net annual operating savings in the illustration</th>
            </tr>
          </thead>
          <tbody data-id="element-2453" data-mp="1nxtxeqmbe0rc">
            {governmentRanges.map(range => <tr key={range.model} className="border-b border-line last:border-b-0 align-top" data-id="element-2454" data-mp="19xsy3flp71dz">
                <th scope="row" className="px-5 py-4 font-heading font-semibold text-ink-dark" data-id="element-2455" data-mp="1ev2mqt19j90r">{range.model}</th>
                <td className="px-5 py-4 text-ink-dark leading-relaxed" data-id="element-2456" data-mp="22mq3wj8q35pu">{range.positions}</td>
                <td className="px-5 py-4 text-ink-dark leading-relaxed" data-id="element-2457" data-mp="26lyzltnbpdo1">{range.savings}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-sm text-ink-muted leading-relaxed" data-id="element-2458" data-mp="1xugingijyttw">{governmentScopeNote}</p>

      <AssumptionsDisclosure data-id="element-2459" data-mp="2lkaqfjo0ls7a">
        <p className="text-sm text-ink-dark leading-relaxed" data-id="element-2460" data-mp="2lj9hpluh1hsq">{governmentBaseline}</p>
        <div className="mt-4 overflow-x-auto rounded-md border border-line" data-id="element-2461" data-mp="2qbj5owc107sd">
          <table className="w-full min-w-[48rem] text-left text-sm" data-id="element-2462" data-mp="306zp5jag01cm">
            <caption className="sr-only" data-id="element-2463" data-mp="30684h3idvo14">Annual assumptions for each scenario, in USD</caption>
            <thead data-id="element-2464" data-mp="2v8oghbvvvwvz">
              <tr className="border-b border-line bg-surface-bg" data-id="element-2465" data-mp="2v62c1l4ahxhz">
                <th scope="col" className="px-4 py-3 font-semibold text-ink-dark" data-id="element-2466" data-mp="2q78unhlvtmcj">Annual assumption</th>
                {governmentAssumptionColumns.map(column => <th key={column} scope="col" className="px-4 py-3 font-semibold text-ink-dark whitespace-nowrap" data-id="element-2467" data-mp="2h8dog5iu8c98">
                    {column}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-2468" data-mp="27j3xwu3n71n8">
              {governmentAssumptionRows.map(row => <tr key={row.label} className={`border-b border-line last:border-b-0 ${row.emphasis ? 'bg-surface-bg' : ''}`} data-id="element-2469" data-mp="22k0rp6bxepdo">
                  <th scope="row" className={`px-4 py-3 text-left ${row.emphasis ? 'font-semibold text-ink-dark' : 'font-normal text-ink-dark'}`} data-id="element-2470" data-mp="1xjmukjbv4zuf">
                    {row.label}
                  </th>
                  {row.values.map((value, index) => <td key={`${row.label}-${governmentAssumptionColumns[index]}`} className={`px-4 py-3 tabular-nums ${row.emphasis ? 'font-semibold text-ink-dark' : 'text-ink-muted'}`} data-id="element-2471" data-mp="d1kn4far892c" data-mpi={index}>
                      {value}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-sm text-ink-dark leading-relaxed" data-id="element-2472" data-mp="3qg8oe1mm5j65">
          <span className="font-semibold" data-id="element-2473" data-mp="3vg3dbzmtvyok">Formula: </span>
          {governmentFormula}
        </p>
        <ul className="mt-3 space-y-2" data-id="element-2474" data-mp="41fgw8hargpr">
          {governmentCaveats.map(caveat => <li key={caveat} className="text-sm text-ink-muted leading-relaxed" data-id="element-2475" data-mp="438rfyv16l31">
              {caveat}
            </li>)}
        </ul>
      </AssumptionsDisclosure>
    </>;
}